import header from "./bauplan-4-zimmer-wohnung.webp";
import section1 from "./grundriss-4-zimmer-wohnung.jpg";
import section2 from "./detaillierter-grundriss.jpg";
import section3 from "./grundriss-3-zimmer-wohnung.webp";
import section4 from "./bemasster-grundriss.webp";
import section5 from "./tablet-near-drafting-supplies.jpg";
import section6 from "./grundriss-4-zimmer-wohnung-mit-3d-modell.webp";
import section7 from "./grundriss-3-zimmer-wohnung-2.webp";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
